module.exports = {
  VectorShape: {
    PluginName: "Shape",
  },
};
